import { computed, ref } from 'vue';

const appearance = ref(getStoredAppearance() || 'light');

export function updateTheme(value) {
    if (typeof window === 'undefined') {
        return;
    }

    if (value === 'system') {
        const mediaQueryList = window.matchMedia('(prefers-color-scheme: dark)');
        const systemTheme = mediaQueryList.matches ? 'dark' : 'light';

        document.documentElement.classList.toggle('dark', systemTheme === 'dark');
    } else {
        document.documentElement.classList.toggle('dark', value === 'dark');
    }
}

function setCookie(name, value, days = 365) {
    if (typeof document === 'undefined') {
        return;
    }

    const maxAge = days * 24 * 60 * 60;
    document.cookie = `${name}=${value};path=/;max-age=${maxAge};SameSite=Lax`;
}

function mediaQuery() {
    if (typeof window === 'undefined') {
        return null;
    }

    return window.matchMedia('(prefers-color-scheme: dark)');
}

function getStoredAppearance() {
    if (typeof window === 'undefined') {
        return null;
    }

    return localStorage.getItem('appearance');
}

function handleSystemThemeChange() {
    const currentAppearance = getStoredAppearance();
    updateTheme(currentAppearance || 'light');
}

export function initializeTheme() {
    if (typeof window === 'undefined') {
        return;
    }

    const savedAppearance = getStoredAppearance();
    appearance.value = savedAppearance || 'light';
    updateTheme(appearance.value);

    const mq = mediaQuery();
    if (mq) {
        mq.addEventListener('change', handleSystemThemeChange);
    }
}

export function useAppearance() {
    const isDark = computed(() => {
        if (appearance.value === 'dark') {
            return true;
        }
        if (appearance.value === 'light') {
            return false;
        }

        if (typeof window === 'undefined') {
            return false;
        }

        return window.matchMedia('(prefers-color-scheme: dark)').matches;
    });

    function updateAppearance(value) {
        appearance.value = value;
        localStorage.setItem('appearance', value);
        setCookie('appearance', value);
        updateTheme(value);
    }

    function toggleDarkMode() {
        updateAppearance(isDark.value ? 'light' : 'dark');
    }

    return {
        appearance,
        isDark,
        updateAppearance,
        toggleDarkMode,
    };
}
